import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 q-pb-md"
}
const _hoisted_3 = { class: "col-12 q-pb-md" }
const _hoisted_4 = {
  key: 1,
  class: "col-12 q-pb-md"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-5 q-pb-md" }
const _hoisted_7 = { class: "col-7 q-pb-md" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 q-pb-md" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-12 q-pb-md" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 q-pb-md" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-negative text-bold" }, " OBS: Denna text överförs till beställaren ", -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-8 q-pb-md" }
const _hoisted_17 = { class: "col-4 q-pb-md" }
const _hoisted_18 = { class: "row bg-grey-3" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 0,
  class: "row q-pa-md"
}
const _hoisted_21 = { class: "col-8 q-pb-md" }
const _hoisted_22 = { class: "col-4 q-pb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFieldSelect = _resolveComponent("AppFieldSelect")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!
  const _component_AppFieldDate = _resolveComponent("AppFieldDate")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.formType === 'create')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_AppFieldSelect, {
              modelValue: _ctx.vehicleComposition,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vehicleComposition) = $event)),
              label: "Tågsätt",
              options: _ctx.availableVehicleCompositionsValid,
              "option-value": "uuid",
              "option-label": 
          (x) =>
            `${
              x.vehicles
                ? `${x.vehicles.map((x) => x.name).join(' ')} `
                : `${x.uuid}`
            }`
        ,
              "emit-value": "",
              "map-options": ""
            }, null, 8, ["modelValue", "options", "option-label"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.formType === 'create')
          ? (_openBlock(), _createBlock(_component_AppFieldSelect, {
              key: 0,
              modelValue: _ctx.vehicleUuids,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vehicleUuids) = $event)),
              multiple: "",
              "hide-select": false,
              "use-chips": "",
              label: "Fordon",
              options: _ctx.vehicles,
              "option-value": "uuid",
              "option-label": 
          (x) =>
            `${x.name} ${
              x.vehicle_type?.name ? ` (${x.vehicle_type?.name})` : ''
            }`
        ,
              "emit-value": "",
              "map-options": "",
              rules: [_ctx.requiredRule],
              onClear: _cache[2] || (_cache[2] = () => (_ctx.vehicleUuids = []))
            }, null, 8, ["modelValue", "options", "option-label", "rules"]))
          : (_openBlock(), _createBlock(_component_AppFieldSelect, {
              key: 1,
              modelValue: _ctx.model.vehicle_uuid,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.vehicle_uuid) = $event)),
              label: "Fordon",
              readonly: true,
              options: _ctx.vehicles,
              "option-value": "uuid",
              "option-label": 
          (x) =>
            `${x.name} ${
              x.vehicle_type?.name ? ` (${x.vehicle_type?.name})` : ''
            }`
        ,
              "emit-value": "",
              "map-options": "",
              rules: [_ctx.requiredRule]
            }, null, 8, ["modelValue", "options", "option-label", "rules"]))
      ]),
      (_ctx.errorValidVehicles.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorValidVehicles, (error, $i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: $i,
                style: {"border-radius":"2px"},
                class: "text-white text-caption q-mb-xs flex items-center bg-red q-pl-xs"
              }, [
                _createVNode(_component_q_icon, { name: "mdi-alert-circle-outline q-mr-sm" }),
                _createTextVNode(" Fordon " + _toDisplayString(error.name) + " är redan avställd ", 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppFieldSelect, {
          modelValue: _ctx.model.vehicle_withdrawal_responsible_uuid,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.vehicle_withdrawal_responsible_uuid) = $event)),
          label: "Ansvarig",
          options: _ctx.responsibles,
          rules: [_ctx.requiredRule],
          "option-value": "uuid",
          "option-label": "name",
          "emit-value": "",
          "map-options": ""
        }, null, 8, ["modelValue", "options", "rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppFieldSelect, {
          modelValue: _ctx.model.vehicle_withdrawal_depot_uuid,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.vehicle_withdrawal_depot_uuid) = $event)),
          label: "Avställningsdepå",
          options: _ctx.depots,
          rules: [_ctx.requiredRule],
          "option-value": "uuid",
          "option-label": "name",
          "emit-value": "",
          "map-options": ""
        }, null, 8, ["modelValue", "options", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_AppFieldSelect, {
          modelValue: _ctx.model.vehicle_withdrawal_reason_uuid,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.vehicle_withdrawal_reason_uuid) = $event)),
          label: "Anledning till avställning",
          options: _ctx.reasons,
          rules: [_ctx.requiredRule],
          "option-value": "uuid",
          "option-label": "name",
          "emit-value": "",
          "map-options": ""
        }, null, 8, ["modelValue", "options", "rules"])
      ])
    ]),
    _createVNode(_component_q_slide_transition, null, {
      default: _withCtx(() => [
        (_ctx.showEventIdInput)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  square: "",
                  label: "Händelse ID",
                  type: "number",
                  modelValue: _ctx.model.event_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.event_id) = $event)),
                  modelModifiers: { number: true },
                  rules: [_ctx.minCharactersRule(6)]
                }, null, 8, ["modelValue", "rules"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_q_input, {
          type: "textarea",
          rows: "3",
          modelValue: _ctx.model.comment,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.comment) = $event)),
          "input-style": { resize: 'none' },
          outlined: "",
          "bottom-slots": "",
          square: "",
          label: "Kommentar"
        }, {
          hint: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_AppFieldDate, {
          readonly: 
          _ctx.formType === 'update' && !_ctx.can('vehicleWithdrawal.createBackInTime')
        ,
          outlined: "",
          label: "Avställd",
          modelValue: _ctx.withdrawnDate,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.withdrawnDate) = $event)),
          rules: [_ctx.validDateRule]
        }, null, 8, ["readonly", "modelValue", "rules"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_q_input, {
          readonly: 
          _ctx.formType === 'update' && !_ctx.can('vehicleWithdrawal.createBackInTime')
        ,
          outlined: "",
          square: "",
          type: "time",
          modelValue: _ctx.withdrawnTime,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.withdrawnTime) = $event)),
          rules: [_ctx.requiredRule]
        }, null, 8, ["readonly", "modelValue", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.showPrognosis,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showPrognosis) = $event)),
          label: "Sätt prognos"
        }, null, 8, ["modelValue"]),
        (_ctx.showPrognosis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_AppFieldDate, {
                  outlined: "",
                  label: "Prognos",
                  modelValue: _ctx.prognosisDate,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.prognosisDate) = $event)),
                  rules: [_ctx.validDateRule]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  square: "",
                  type: "time",
                  modelValue: _ctx.prognosisTime,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.prognosisTime) = $event)),
                  rules: [_ctx.requiredRule]
                }, null, 8, ["modelValue", "rules"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}